import * as React from "react";
import { defer, redirect, useRouteLoaderData } from "react-router-dom"
import { createfollowupInspection } from "@app/models/inspection"
import { nextStep, nextStepRedirect } from "@app/utils/inspection";
import FormStepContainer from "@app/components/inspection-form/FormStepContainer.jsx";
import Config from "@app/constants/Config"
let pendingAction = null;

export const action = async ({ request, params }) => {
    const { inspectionId: initialUUID, action } = params;
    const formData = await request.formData();
    const data = await JSON.parse(formData.get("json"));
    const { uuid, saveAsync } = await createfollowupInspection(data, initialUUID);
	pendingAction = saveAsync;

    const replacePath = await nextStep("new", uuid);
    // enable proper back browser navigation
    window.history.replaceState(null, "", replacePath);
    return nextStepRedirect(1, uuid);
};

export async function loader (request) {
	const {
		params: { step, inspectionId }
	} = request;

	if (inspectionId && !step) {
		return redirect(`${Config.BASE_PATH}/inspection/${inspectionId}/1`);
	}

	document.body.scrollIntoView({ behavior: "smooth" }); // @todo: unsure if right spot
	const res = defer({
		syncRequest: pendingAction?.()
	});
	pendingAction = null;
	return res;
}

export default function NewFollowUp() {
    const { inspection } = useRouteLoaderData("inspection");

    return <FormStepContainer inspection={inspection} newType={'FOLLOW_UP'} />;
}
